import { inject as service } from '@ember/service';
import Controller from '@ember/controller';
import { dropTask, timeout } from 'ember-concurrency';
import { handleErrorResponseWithModal } from 'sh-www/utils/handles-errors';
import { tracked } from '@glimmer/tracking';

/**
 * Controller for the Reset Email form in settings.
 */
class TaxesController extends Controller {
  @service api;
  @service session;

  @tracked forceDisplayIframe = false;

  startTime;

  get displayIframe() {
    return this.forceDisplayIframe || this.session.currentUser.taxInformationNeedsAction;
  }

  @dropTask({ drop: true })
  *iframeUrl() {
    try {
      return yield this.api.get(`users/${this.session.currentUser.id}/tax-iframe-url`);
    } catch (e) {
      handleErrorResponseWithModal(this, e, 'Failed to load company groups');
    }
  }

  @dropTask
  *pollCurrentUser() {
    while (true) {
      const elapsedTime = (Date.now() - this.startTime) / 1000;

      if (elapsedTime < 3600) {
        // Under an hour
        yield timeout(10000); // 10 seconds
      } else if (elapsedTime < 14400) {
        // Under 4 hours
        yield timeout(120000); // 2 minutes
      } else {
        // Cancel the poll
        return;
      }

      const taxInformationNeedsAction = this.session.currentUser.taxInformationNeedsAction;

      yield this.session.loadCurrentUser();

      if (taxInformationNeedsAction && !this.session.currentUser.taxInformationNeedsAction) {
        // We transitioned to not needing it, so force the iframe to remain open
        this.forceDisplayIframe = true;
      }
    }
  }
}

export default TaxesController;
